<template>
  <div class="detail">
    <div class="hender">
      <span class="name">{{ info.patientName }}</span>
      <span class="gender">{{ info.grenderStr }}</span>
      <span class="age">{{ info.patientAge }}岁</span>
    </div>
    <div class="con">
      <template v-if="info.sendFlg == 0">
        <div class="title">解读结果</div>
        <div class="title2">解读结果请稍等...</div>
      </template>
      <template v-else>
        <empty v-if="!handData" />
        <template v-else>
          <div class="title">解读结果</div>
          <div v-html="handData"></div>
        </template>
      </template>

      <!-- <div class="title2">健康：</div>
        <div class="con-inf">
          ，眼光较高，因此心仪的对象都很完美，内外在美兼具，气质仪表出众，有深度，只是没有遇到之前容易沉浸在自己的世界。
          只要找到意中的恋人，就会建立幸福的家庭，结婚后大多喜欢依赖伴侣，在对象方面，往往会更加中意和自己有较少共同性或者不同职业、不同背景的伴侣。
        </div> -->
    </div>
  </div>
</template>

<script>
import FormatHandData from "@/utils/FormatHandData.js";
import { mapGetters } from "vuex";
// import data from "./data.js";
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["dicts"]),
    handRareData() {
      return this.dicts.HAND_RARE_DATA || [];
    },
  },
  watch: {
    info: {
      handler(newValue, oldValue) {
        this.getData();
      },
      immediate: true,
    },
  },
  data() {
    return {
      handData: "",
    };
  },
  methods: {
    getData() {
      this.handData = "";
      if (this.info.sendFlg == 0) return;
      this.api2("getOfferHandUnscrambleByAdiId", {
        sex: this.info.gender == "F" ? 2 : 1, //  1 男 2女
        aidId: this.info.aidId, //	明细主键Id
        patientCode: "8888888", //	患者编码
      }).then((res) => {
        if (res.result.handSendResult) {
          this.handData = res.result.handSendResult;
        } else {
          if (res.result.handResult) {
            let fd = new FormatHandData(
              JSON.parse(res.result.handResult),
              this.handRareData
            );
            this.handData = fd.infoList2
              .filter((v) => v.value.some((i) => i.text))
              .map((i) => {
                return `<h4>${i.title}</h4><div class="box">${i.value
                  .map((v) => v.text)
                  .join("<br/>")}</div>`;
              })
              .join("<br/>");
          } else {
            this.handData = "解读失败";
          }
          this.updateAutoDetailInfo();
        }
      });
    },
    updateAutoDetailInfo() {
      this.api2("updateAutoDetailInfo", {
        aidId: this.info.aidId,
        handSendResult: this.handData,
        savePort: 1, //保存端口 在云诊调用初始化系统自动处理时传1，在百会调用初始化系统自动处理时传2，在百会编辑解读结果时传3
      }).then((res) => {});
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .hender {
    font-weight: bold;
    font-size: 17px;
    margin-bottom: 15px;
    span {
      margin-right: 15px;
    }
  }
  .con {
    line-height: 2em;
    height: 100%;
    overflow-y: auto;
  }
  .title {
    font-weight: bold;
    font-size: 15px;
  }
  .title2 {
    font-weight: bold;
  }

  .rare-text {
    display: inline-block;
    color: #2e74ec;
    .xszy-icon {
      color: #2e74ec;
    }
    .r-t-label {
      background: #dfe8f6;
      padding: 0 5px;
      border-radius: 10px;
      margin-right: 4px;
      position: relative;
      cursor: pointer;
      &:hover {
        i {
          display: inline-block;
        }
      }
      i {
        color: #515a6e !important;
        display: none;
        white-space: nowrap;
        font-style: normal;
        color: #666;
        font-size: 13px;
        padding: 5px 10px;
        position: absolute;
        left: 0;
        top: -40px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #fff;
      }
    }
  }
}
</style>